import useRouter from "common/hooks/use-router";
import { useCallback } from "react";
import CrudEdit from "common/components/Crud/CrudEdit";
import UserForm from "./UserForm";

function User() {
  const router = useRouter();

  const id = router.query.id as string;

  const back = useCallback(() => {
    router.navigate("/users");
  }, [router]);

  return (
    <CrudEdit
      collectionName="users"
      id={id}
      Form={UserForm}
      onBack={back}
    />
  );
}

export default User;
